/**
 * Service Worker registration.
 *
 * Enregistre le SW situé à `/service-worker.js` en production uniquement — on
 * évite l'enregistrement en dev pour ne pas rester bloqué sur une version
 * cachée pendant les rebuilds. En preview Emergent (hostname *.preview.*),
 * on active aussi le SW pour pouvoir tester l'expérience "installée".
 *
 * Si une nouvelle version est détectée pendant une session, on demande au
 * SW en attente de prendre le contrôle immédiatement (skipWaiting) puis on
 * recharge la page pour appliquer les changements.
 */

const isDev = process.env.NODE_ENV === "development";
// En dev local, on skip pour éviter les caches gênants pendant les rebuilds.
// En preview Emergent (hostname *.preview.*) et en production, on l'active
// pour pouvoir tester l'expérience "installée" avant d'aller live.
const shouldSkip = () => {
  if (typeof window === "undefined") return true;
  if (!isDev) return false;
  const host = window.location.hostname;
  return !host.includes("preview") && !host.includes("emergentagent") && host !== "helencia.fr";
};

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  if (shouldSkip()) return; // évite les caches en dev localhost only

  const swUrl = "/service-worker.js";

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Une nouvelle version est prête → applique-la sans attendre le prochain reload manuel
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // Une version tourne déjà → demande au nouveau SW de skip waiting
              installing.postMessage?.({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((err) => {
        // Ne pas casser l'app si le SW échoue à s'enregistrer.
        // eslint-disable-next-line no-console
        console.warn("[PWA] SW registration failed:", err);
      });

    // Recharge la page une fois quand un nouveau SW prend le contrôle,
    // pour que l'utilisateur voie la nouvelle version sans intervention.
    let reloading = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}
